module.exports = __webpack_public_path__ + "084a73343adf81671d654442d9beadef.svg";